import Git from "./git_full_components/Git";
import Getting_Started from "./git_full_components/Getting_Started";
import Git_Tutorial from "./git_full_components/Git_Tutorial";
import Git_Home from "./git_full_components/Git_Home";
import Git_Intro from "./git_full_components/Git_Intro";
import Git_Install from "./git_full_components/Git_Install";
import Git_Config from "./git_full_components/Git_Config";
import Git_Get_Started from "./git_full_components/Git_Get_Started";
import Git_New_Files from "./git_full_components/Git_New_Files";
import Git_Staging from "./git_full_components/Git_Staging";
import Git_Commit from "./git_full_components/Git_Commit";
import Git_Tagging from "./git_full_components/Git_Tagging";
import Git_Stash from "./git_full_components/Git_Stash";
import Git_History from "./git_full_components/Git_History";
import Git_Help from "./git_full_components/Git_Help";
import Git_Branch from "./git_full_components/Git_Branch";
import Git_Merge from "./git_full_components/Git_Merge";
import Git_Workflow from "./git_full_components/Git_Workflow";
import Git_Best_Practices from "./git_full_components/Git_Best_Practices";
import Git_Glossary from "./git_full_components/Git_Glossary";
import Git_and_GitHub from "./git_full_components/Git_and_GitHub";
import GitHub_Get_Started from "./git_full_components/GitHub_Get_Started";
import Git_What_is_SSH from "./git_full_components/Git_What_is_SSH";
import GitHub_Add_SSH from "./git_full_components/GitHub_Add_SSH";
import GitHub_Set_Remote from "./git_full_components/GitHub_Set_Remote";
import GitHub_Edit_Code from "./git_full_components/GitHub_Edit_Code";
import Pull_from_GitHub from "./git_full_components/Pull_from_GitHub";
import Push_to_GitHub from "./git_full_components/Push_to_GitHub";
import GitHub_Branch from "./git_full_components/GitHub_Branch";
import Pull_Branch_from_GitHub from "./git_full_components/Pull_Branch_from_GitHub";
import Push_Branch_to_GitHub from "./git_full_components/Push_Branch_to_GitHub";
import GitHub_Flow from "./git_full_components/GitHub_Flow";
import GitHub_Pages from "./git_full_components/GitHub_Pages";
import Git_GUI_Clients from "./git_full_components/Git_GUI_Clients";
import Git_Contribute from "./git_full_components/Git_Contribute";
import GitHub_Fork from "./git_full_components/GitHub_Fork";
import Git_Clone_from_GitHub from "./git_full_components/Git_Clone_from_GitHub";
import GitHub_Send_Pull_Request from "./git_full_components/GitHub_Send_Pull_Request";
import Git_Undo from "./git_full_components/Git_Undo";
import Git_Revert from "./git_full_components/Git_Revert";
import Git_Reset from "./git_full_components/Git_Reset";
import Git_Amend from "./git_full_components/Git_Amend";
import Git_Rebase from "./git_full_components/Git_Rebase";
import Git_Reflog from "./git_full_components/Git_Reflog";
import Git_Recovery from "./git_full_components/Git_Recovery";
import Git_Advanced from "./git_full_components/Git_Advanced";
import Git_gitignore from "./git_full_components/Git_gitignore";
import Git_gitattributes from "./git_full_components/Git_gitattributes";
import Git_Large_File_Storage_LFS from "./git_full_components/Git_Large_File_Storage_LFS";
import Git_Signing_CommitsTags from "./git_full_components/Git_Signing_CommitsTags";
import Git_Cherrypick__Patch from "./git_full_components/Git_Cherrypick__Patch";
import Git_Merge_Conflicts from "./git_full_components/Git_Merge_Conflicts";
import Git_CICD from "./git_full_components/Git_CICD";
import Git_Hooks from "./git_full_components/Git_Hooks";
import Git_Submodules from "./git_full_components/Git_Submodules";
import Git_Remote_Advanced from "./git_full_components/Git_Remote_Advanced";
import Exercises from "./git_full_components/Exercises";
import Git_Exercises from "./git_full_components/Git_Exercises";
import Git_Quiz from "./git_full_components/Git_Quiz";
import Git_Syllabus from "./git_full_components/Git_Syllabus";
import Git_Study_Plan from "./git_full_components/Git_Study_Plan";

import Git_Certificate from "./git_full_components/Git_Certificate";

const AllGitComponents = {
  "<Git />": Git,
  "<Getting_Started />": Getting_Started,
  "<Git_Tutorial />": Git_Tutorial,
  "<Git_Home />": Git_Home,
  "<Git_Intro />": Git_Intro,
  "<Git_Install />": Git_Install,
  "<Git_Config />": Git_Config,
  "<Git_Get_Started />": Git_Get_Started,
  "<Git_New_Files />": Git_New_Files,
  "<Git_Staging />": Git_Staging,
  "<Git_Commit />": Git_Commit,
  "<Git_Tagging />": Git_Tagging,
  "<Git_Stash />": Git_Stash,
  "<Git_History />": Git_History,
  "<Git_Help />": Git_Help,
  "<Git_Branch />": Git_Branch,
  "<Git_Merge />": Git_Merge,
  "<Git_Workflow />": Git_Workflow,
  "<Git_Best_Practices />": Git_Best_Practices,
  "<Git_Glossary />": Git_Glossary,
  "<Git_and_GitHub />": Git_and_GitHub,
  "<GitHub_Get_Started />": GitHub_Get_Started,
  "<Git_What_is_SSH />": Git_What_is_SSH,
  "<GitHub_Add_SSH />": GitHub_Add_SSH,
  "<GitHub_Set_Remote />": GitHub_Set_Remote,
  "<GitHub_Edit_Code />": GitHub_Edit_Code,
  "<Pull_from_GitHub />": Pull_from_GitHub,
  "<Push_to_GitHub />": Push_to_GitHub,
  "<GitHub_Branch />": GitHub_Branch,
  "<Pull_Branch_from_GitHub />": Pull_Branch_from_GitHub,
  "<Push_Branch_to_GitHub />": Push_Branch_to_GitHub,
  "<GitHub_Flow />": GitHub_Flow,
  "<GitHub_Pages />": GitHub_Pages,
  "<Git_GUI_Clients />": Git_GUI_Clients,
  "<Git_Contribute />": Git_Contribute,
  "<GitHub_Fork />": GitHub_Fork,
  "<Git_Clone_from_GitHub />": Git_Clone_from_GitHub,
  "<GitHub_Send_Pull_Request />": GitHub_Send_Pull_Request,
  "<Git_Undo />": Git_Undo,
  "<Git_Revert />": Git_Revert,
  "<Git_Reset />": Git_Reset,
  "<Git_Amend />": Git_Amend,
  "<Git_Rebase />": Git_Rebase,
  "<Git_Reflog />": Git_Reflog,
  "<Git_Recovery />": Git_Recovery,
  "<Git_Advanced />": Git_Advanced,
  "<Git_gitignore />": Git_gitignore,
  "<Git_gitattributes />": Git_gitattributes,
  "<Git_Large_File_Storage_LFS />": Git_Large_File_Storage_LFS,
  "<Git_Signing_CommitsTags />": Git_Signing_CommitsTags,
  "<Git_Cherrypick__Patch />": Git_Cherrypick__Patch,
  "<Git_Merge_Conflicts />": Git_Merge_Conflicts,
  "<Git_CICD />": Git_CICD,
  "<Git_Hooks />": Git_Hooks,
  "<Git_Submodules />": Git_Submodules,
  "<Git_Remote_Advanced />": Git_Remote_Advanced,
  "<Exercises />": Exercises,
  "<Git_Exercises />": Git_Exercises,
  "<Git_Quiz />": Git_Quiz,
  "<Git_Syllabus />": Git_Syllabus,
  "<Git_Study_Plan />": Git_Study_Plan,
  "<Git_Certificate />": Git_Certificate,
};

export default AllGitComponents;
